import { render, staticRenderFns } from "./InputQuillEditor.vue?vue&type=template&id=63248005"
import script from "./InputQuillEditor.vue?vue&type=script&lang=js"
export * from "./InputQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./InputQuillEditor.vue?vue&type=style&index=0&id=63248005&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports